// src/utils/api.js
// ── Point this at your live API ──────────────────────────────
// Your API is at: https://venkatagirihandlooms.com/api/routes/
// The router (index.php) is not being used — routes are called directly.
// So we call the route files directly with ?resource=xxx pattern,
// OR we use the index.php router with clean URLs.
//
// Since your files work at /api/routes/products.php directly,
// the simplest fix: point BASE_URL at the routes folder and
// call each file directly.

const BASE_URL = 'https://venkatagirihandlooms.com/api/routes';

const getHeaders = () => {
  const token = localStorage.getItem('vkg_token');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

// Map clean API paths → actual PHP files
// e.g.  /products          → products.php
//        /products/slug     → products.php?slug=slug
//        /categories        → categories.php
//        /auth/login        → auth.php (with action=login in body)
//        /cart              → cart.php
//        /orders            → orders.php
function resolvePath(path) {
  // Strip leading slash
  path = path.replace(/^\//, '');

  // Split into segments:  "products/kanchi-cotton" → ["products","kanchi-cotton"]
  const [resource, id, sub] = path.split('?')[0].split('/');
  const queryString = path.includes('?') ? path.split('?')[1] : '';

  let file = resource + '.php';
  let qs   = queryString ? '?' + queryString : '';

  // For routes that use sub-resources: auth/login → auth.php?action=login
  if (resource === 'auth' && id) {
    qs = '?action=' + id + (queryString ? '&' + queryString : '');
    file = 'auth.php';
  } else if (resource === 'admin' && id) {
    qs = '?action=' + id + (sub ? '&sub=' + sub : '') + (queryString ? '&' + queryString : '');
    file = 'admin.php';
  } else if (id) {
    // products/kanchi-cotton → products.php?slug=kanchi-cotton
    qs = '?slug=' + id + (sub ? '&sub=' + sub : '') + (queryString ? '&' + queryString : '');
  }

  return `${BASE_URL}/${file}${qs}`;
}

async function request(method, path, body = null) {
  const url = resolvePath(path);
  const res = await fetch(url, {
    method,
    headers: getHeaders(),
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  let json;
  try {
    json = await res.json();
  } catch (e) {
    throw new Error('Server returned invalid JSON. Check API for PHP errors.');
  }

  if (!json.success && res.status >= 400) {
    throw new Error(json.error || 'Request failed');
  }
  return json;
}

export const api = {
  get:    (path)       => request('GET',    path),
  post:   (path, body) => request('POST',   path, body),
  put:    (path, body) => request('PUT',    path, body),
  delete: (path)       => request('DELETE', path),
};

export default api;
